type ApproverType = 'quality' | 'other' | 'mergedApprovers';

export function computeRequiredApproverSelections({
  approverType,
  qualityApprovalRequired,
  unmanagedApproversCount,
}: {
  approverType: ApproverType;
  qualityApprovalRequired: boolean;
  unmanagedApproversCount: number;
}): number | undefined {
  if (qualityApprovalRequired === false) {
    return unmanagedApproversCount === 0 ? 1 : undefined;
  }
  return approverType === 'quality' ? 1 : undefined;
}
